//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpForm',
  props: {
    condensed: { type: Boolean, default: false },
    name: { type: String, default: null },
  },
  methods: {
    handleSubmit(e) {
      this.$emit('submit', e);
    },
  },
};
